<template>
  <div class="input-group bootstrap-timepicker p-l-0 p-r-0 m-b-10">
    <label v-show="displayLabelText" class="label--datetime">{{ labelText }}</label>
    <input type="text" class="form-control" :value="value" ref="input" @input="checkEmpty">
    <span class="input-group-addon"><i class="pg-clock"></i></span>
  </div>
</template>

<script>
export default {
  name: "time-picker",
  props: ['labelText', 'value', 'isCheckEmpty'],
  data: function(){
    return {
      shouldBeEmitted: true
    }
  },
  computed: {
    displayLabelText() {
      return this.labelText != null
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      this.shouldBeEmitted = false
      $(this.$refs.input).timepicker("setTime", newValue);
    }
  },
  methods: {
    updateValue() {
      if(this.shouldBeEmitted){
        this.$emit('input', this.$refs.input.value)
      } else {
        this.shouldBeEmitted = true
      }
    },
    checkEmpty(){
      if (this.isCheckEmpty && this.$refs.input.value == '') {
        this.$emit('input', '')
      }
    }
  },
  mounted: function(){
    var self = this;
    $(this.$refs.input).timepicker({
      minuteStep: 1,
      showMeridian: false,
    })
    .on('show.timepicker', function(e) {
      var widget = $('.bootstrap-timepicker-widget');
      widget.find('.glyphicon-chevron-up').removeClass().addClass('pg-arrow_maximize');
      widget.find('.glyphicon-chevron-down').removeClass().addClass('pg-arrow_minimize');
    })
    .on("changeTime.timepicker", function(e){
      self.updateValue()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/TimePicker.vue